const reportSectionsBasePath = '/report-sections';

export class ReportSectionPath {
  static index() {
    return reportSectionsBasePath;
  }
}
